var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-search-select',_vm._b({attrs:{"route":_vm.route,"option-label":"text","clearable":"","placeholder":"پاسخ های آماده..."},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var itemProps = ref.itemProps;
var itemEvents = ref.itemEvents;
var opt = ref.opt;
var selected = ref.selected;
var toggleOption = ref.toggleOption;
return [_c('q-item',_vm._g(_vm._b({},'q-item',itemProps,false),itemEvents),[_c('q-item-section',[_c('q-item-label',{staticStyle:{"max-width":"400px"}},[_c('text-ellipsis',{attrs:{"text":opt.text}})],1)],1)],1)]}}]),model:{value:(_vm.preDefinedIdValue),callback:function ($$v) {_vm.preDefinedIdValue=$$v},expression:"preDefinedIdValue"}},'entity-search-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }